exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".agreementWrap {\n  margin: 0 80px;\n  padding: 60px 0;\n}\n.agreementWrap h3 {\n  font-size: 40px;\n  text-align: center;\n  color: theme-color();\n}\n.agreementWrap p {\n  font-size: 26px;\n  color: #888;\n  line-height: 40px;\n  margin-top: 20px;\n  text-align: justify;\n}\n.agreementWrap .addBold {\n  color: #666;\n  font-weight: 600;\n}\n.agreementWrap .addBoldColor {\n  color: theme-color();\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"modules":false,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./~/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#0070C2","@font-size-base":"12px","@primary-1 ":"#f2f2f2"}}!./src/page/Agreement/index.less
// module id = 1245
// module chunks = 0